import axios from 'axios'

class AuthApi {
  constructor() {
    this.endpoint = import.meta.env.VITE_APP_GW_URL
    this.systemId = import.meta.env.VITE_APP_SYSTEMID
  }

  async login(username, password) {
    const params = new URLSearchParams()
    params.append('grant_type', 'password')
    params.append('client_id', 'dangam')
    params.append('client_secret', 'dg2021')
    params.append('username', username)
    params.append('password', password)
    params.append('system_id', this.systemId)

    //01> 토큰생성
    const response1 = await this.userToken(params)
    let userData = { ...response1 }
    return userData

    //02> 전체메뉴리스트받아오기(Tree)
    //const response2 = await this.treeMenu(response1)
    //02> 메뉴권한받아오기(Auth)
    //const response3 = await this.userMenu(response1)

    //useCookie("accessToken").value = response1.access_token

    //let userData = { ...response1, treeMenu: response2, userMenu: response3 }
  }

  //01> 액세스토큰
  async userToken(params) {
    return axios.post(`${this.endpoint}/oauth/token`, params).then((response) => {
      return response.data
    })
  }

  //02> 전체메뉴트리구조
  async treeMenu(data) {
    //headers : 정의
    axios.defaults.headers.common['Authorization'] = `bearer ${data.access_token}`
    axios.defaults.headers.common['authUserId'] = data.id
    return axios
      .get(`${this.endpoint}/menus/tree?isSideShow=false&systemId=${this.systemId}`)
      .then((response) => {
        return response.data
      })
  }

  //03> 메뉴권한 전체
  async userMenu(data) {
    //headers : 정의
    axios.defaults.headers.common['Authorization'] = `bearer ${data.access_token}`
    axios.defaults.headers.common['authUserId'] = data.id

    return axios
      .get(`${this.endpoint}/auths?userId=${data.id}&systemId=${this.systemId}`)
      .then((response) => {
        return response.data
      })
  }

  async getAuth(menuId) {
    axios
      .get(`/auths/pages?menuId=${menuId}`)
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        console.log(error)
      })
  }

  async getAuthAll(userId) {
    return axios.get(`${this.endpoint}/auths?userId=${userId}`).then((response) => {
      return response.data
    })
  }

  async saveAuthAll(auth) {
    console.log('auth')
    console.log(auth)
    return axios.put(`${this.endpoint}/auths`, auth).then((response) => {
      return response.data
    })
  }

  async refresh(refresh_token) {
    const params = new URLSearchParams()
    params.append('grant_type', 'refresh_token')
    params.append('client_id', 'dangam')
    params.append('client_secret', 'dg2021')
    params.append('refresh_token', refresh_token)
    return axios
      .create()
      .post(`${this.endpoint}/oauth/refresh`, params)
      .then((response) => response.data)
  }

  // 복지찬스(SmartWel) 제휴 진입: JWT를 낭만만세력 토큰으로 교환
  // - autoSignUp: false → 미가입·미연동 회원이면 404 반환 (가입 여부 검사용)
  // - autoSignUp: true  → 미가입이면 자동 가입 후 토큰 발급
  async partnerSmartwel(token, autoSignUp = true) {
    return axios
      .create()
      .post(`${this.endpoint}/oauth/partner/smartwel`, { token, autoSignUp })
      .then((response) => response.data)
  }

  // ===== OAuth 추가 연동 (PKCE) =====

  /**
   * 소셜 OAuth 연동 시작.
   * 인증된 사용자만 호출 가능 (axios 글로벌 인터셉터가 Authorization 헤더 첨부).
   *
   * @param {'google'|'naver'|'kakao'|'apple'} provider
   * @param {string} codeChallenge - base64url(SHA-256(code_verifier))
   * @param {string} returnPath - 콜백 후 돌아올 경로 ('/'로 시작, path-only)
   * @returns {Promise<{ provider: string, authorizationUrl: string, expiresIn: number }>}
   */
  async startOAuthLink(provider, codeChallenge, returnPath) {
    return axios
      .get(`${this.endpoint}/oauth/link/${provider}`, {
        params: { codeChallenge, returnPath },
      })
      .then((response) => response.data)
  }

  /**
   * 소셜 OAuth 연동 완료 (콜백에서 받은 code 교환).
   *
   * @param {string} provider
   * @param {string} code - returnPath query에서 받은 link_code (nmc_ prefix)
   * @param {string} codeVerifier - 시작 단계에서 보관한 verifier
   * @returns {Promise<{ provider: string, linked: boolean, alreadyLinked: boolean }>}
   */
  async completeOAuthLink(provider, code, codeVerifier) {
    return axios
      .post(`${this.endpoint}/oauth/link/${provider}`, { code, codeVerifier })
      .then((response) => response.data)
  }

  /**
   * 소셜 OAuth 연동 해제 (smartwel 포함).
   *
   * @param {'google'|'naver'|'kakao'|'apple'|'smartwel'} provider
   * @returns {Promise<{ provider: string, unlinked: boolean }>}
   */
  async unlinkOAuth(provider) {
    return axios
      .delete(`${this.endpoint}/oauth/link/${provider}`)
      .then((response) => response.data)
  }

  /**
   * 복지찬스(SmartWel) 추가 연동 (이미 로그인된 회원에 smartwel 연결).
   *
   * @param {string} token - smartwel JWT
   * @returns {Promise<{ provider: 'smartwel', linked: boolean, alreadyLinked: boolean, totalPoint: number|null }>}
   */
  async linkPartnerSmartwel(token) {
    return axios
      .post(`${this.endpoint}/oauth/partner/smartwel/link`, { token })
      .then((response) => response.data)
  }
}

export default new AuthApi()
